import { IStageStatusPair, IStageData } from 'wisestep-api';

import { IBusinessData } from '../../crmSettings/customizeStageStatus/helper';

const convertBdToStageStatusPair = (businessDefinition: IBusinessData) => {
  const statusPairsArray: IStageStatusPair[] = [];
  businessDefinition.stageStatusData.forEach((stageData: IStageData) => {
    stageData.selectedStatuses.map((status) => {
      statusPairsArray.push({
        applicationStage: stageData.stage,
        applicationState: status,
      });
    });
  });
  return statusPairsArray;
};

export default convertBdToStageStatusPair;
